export function combineUrlAndParams(
  url: string,
  params: { [key: string]: string | number | boolean | undefined }
) {
  const query = Object.keys(params)
    .filter((k) => params[k] !== undefined)
    .sort() /* Sort array so that the URL is always the same for the same params, for use in react-query keys */
    .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent("" + params[k]))
    .join("&");

  if (query) {
    if (url.includes("?")) {
      return url + "&" + query;
    } else {
      return url + "?" + query;
    }
  }
  return url;
}

export function createAbsoluteUrl(path: string) {
  const start = `${window.location.protocol}//${window.location.host}`;

  if (path.startsWith("/")) {
    return start + path;
  } else {
    return start + "/" + path;
  }
}

export function ensureUrlWithoutTrailingSlash(url: string) {
  if (url.endsWith("/")) {
    return url.slice(0, -1);
  } else {
    return url;
  }
}

/* Returns a Record with keys search params as keys, and an *array* of strings
   as values, in case a key occurred multiple times.

   This Record should then be parsed using e.g. Zod to check that it has the right data,
   a value that can only have a single value does indeed have only one, et cetera.
 */
export function valuesFromSearchParams(searchParams: URLSearchParams) {
  return Array.from(searchParams.keys()).reduce(
    (values, key) => ({
      ...values,
      [key]: searchParams.getAll(key),
    }),
    {} as Record<string, Array<string>>
  );
}
